// 发布表单校验（纯函数，便于单独断言；不涉及任何存储与请求）
import { categories } from "../data/categories";

export interface PublishForm {
  category: string;
  subCategory: string;
  title: string;
  description: string;
  price: string;
  contactName: string;
  contactPhone: string;
}

export type PublishErrors = Partial<Record<keyof PublishForm, string>>;

export const TITLE_MIN = 5;
export const TITLE_MAX = 50;
export const DESC_MIN = 10;
export const DESC_MAX = 500;

/** 手机号或固话（含区号、可带连字符） */
const PHONE_RE = /^(1[3-9]\d{9}|0\d{2,3}-?\d{7,8})$/;

export function emptyPublishForm(): PublishForm {
  return {
    category: "",
    subCategory: "",
    title: "",
    description: "",
    price: "",
    contactName: "",
    contactPhone: "",
  };
}

export function validatePublishForm(form: PublishForm): PublishErrors {
  const errors: PublishErrors = {};

  const category = categories.find((item) => item.slug === form.category);
  if (!category) {
    errors.category = "请选择信息分类";
  } else if (
    form.subCategory &&
    !category.subCategories.some((item) => item.slug === form.subCategory)
  ) {
    errors.subCategory = "子分类与所选分类不匹配";
  }

  const title = form.title.trim();
  if (!title) {
    errors.title = "请填写信息标题";
  } else if (title.length < TITLE_MIN) {
    errors.title = `标题至少 ${TITLE_MIN} 个字`;
  } else if (title.length > TITLE_MAX) {
    errors.title = `标题最多 ${TITLE_MAX} 个字`;
  }

  const description = form.description.trim();
  if (!description) {
    errors.description = "请填写详细描述";
  } else if (description.length < DESC_MIN) {
    errors.description = `描述至少 ${DESC_MIN} 个字`;
  } else if (description.length > DESC_MAX) {
    errors.description = `描述最多 ${DESC_MAX} 个字`;
  }

  if (!form.price.trim()) {
    errors.price = "请填写价格，无固定价格可填「面议」";
  }

  if (!form.contactName.trim()) {
    errors.contactName = "请填写联系人";
  }

  const phone = form.contactPhone.trim();
  if (!phone) {
    errors.contactPhone = "请填写联系电话";
  } else if (!PHONE_RE.test(phone)) {
    errors.contactPhone = "请填写正确的手机号或座机号";
  }

  return errors;
}

export function hasErrors(errors: PublishErrors): boolean {
  return Object.keys(errors).length > 0;
}
